import { render, staticRenderFns } from "./ModuleSettings.vue?vue&type=template&id=ec574a28&scoped=true&"
import script from "./ModuleSettings.vue?vue&type=script&lang=ts&"
export * from "./ModuleSettings.vue?vue&type=script&lang=ts&"
import style0 from "./moduleSettings.scss?vue&type=style&index=0&id=ec574a28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec574a28",
  null
  
)

export default component.exports